import React from 'react';
import Anime from 'react-anime';
import './PhaseOneAnimation.scss';
export default ({ isActive }) => {

  const moveBall = {
    translateY: [
      { value: '-120vh', duration: 0, },
      { value: '120vh', duration: 3000, easing: 'linear'},
    ],
    opacity: [
      { value: 0, duration: 0, },
      { value: 1, duration: 2000,},
      { value: 0, duration: 0},
    ]
  }

  const moveBallDown = {
    translateX: [
      { value: '-100vw', duration: 0, delay:  500},
      { value: 0, duration: 1000, easing: 'linear'},
    ],
    scale: [
      { value: 1, duration: 0, delay: 1500},
      { value: 3.5, duration: 1000, easing: 'linear'},
    ]
  }

  const fadeBall = {
    opacity: [
      { value: 1, duration: 0 },
    ]
  }

  return (
    <div className={`phase-one-animation`}>
      <div className="mobile-mask">
        <div></div>
      </div>
      <div className={`pipe main-pipe`}>
        {isActive && (
          <Anime {...moveBall} className="ball">
            <div></div>
          </Anime>
        )}
      </div>
      <div className={`pipe bg-pipe`}>
        {isActive && (
          <Anime {...moveBallDown} className="ball1">
            <div>
              <Anime {...fadeBall} className="picture-ball"></Anime>
            </div>
          </Anime>
        )}
      </div>
    </div>
  );
};